export function useShare(shareData: {
  title: string
  text: string
  url?: string
}) {
  const canShare = ref(false)
  const data = {
    url: typeof window !== 'undefined' ? window.location.href : '',
    ...shareData,
  }

  onMounted(() => {
    if (typeof navigator.canShare === 'function' && navigator.canShare(data)) {
      canShare.value = true
    }
  })

  async function share() {
    try {
      await navigator.share(data)
    } catch (err) {
      console.error(err)
    }
  }

  return {
    canShare,
    share,
  }
}
